import { useState, useEffect } from 'react';

function useWindowDimensions() {
    const hasWindow = typeof window !== 'undefined';

    function getWindowDimensions() {
        const width = hasWindow ? window.innerWidth : null;
        const height = hasWindow ? window.innerHeight : null;
        return {
            width: width ? width * 0.6 : null, // the grid for the plot is 60vw
            height: height ? height * 0.9 : null, // the grid for the plot is 90vh
        };
    }

    const [windowDimensions, setWindowDimensions] = useState(getWindowDimensions);

    useEffect(() => {
        if (hasWindow) {
            function handleResize() {
                setWindowDimensions(getWindowDimensions());
            }
            window.addEventListener('resize', handleResize);
            return () => window.removeEventListener('resize', handleResize);
        }
    }, [hasWindow]);

    return windowDimensions;
}

export default useWindowDimensions;
